export function download(url: string, fileName: string = 'true') {
  const element = document.createElement('a');

  element.setAttribute('href', url);
  element.setAttribute('download', fileName);

  element.style.display = 'none';

  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function transformToDataUrl(text: string) {
  return `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`;
}
